import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/common/Layout";
import SlideShow from "../../components/Loading/SlideShow";
import WhosNext from "../../components/Loading/WhosNext";
import { useLoadingAnimation } from "../../hooks/useLoadingAnimation";
import { usePrayerSelector } from "../../hooks/usePrayerSelector";
import { trackLoadingComplete } from "../../utils/analytics";
import styles from "./LoadingPage.module.css";

// 타이틀 이미지들 import
import title1 from "../../assets/loading_title1.webp";
import title2 from "../../assets/loading_title2.webp";
import title3 from "../../assets/loading_title3.webp";
import title4 from "../../assets/loading_title4.webp";

const titleImageMap = {
  "loading_title1.webp": title1,
  "loading_title2.webp": title2,
  "loading_title3.webp": title3,
  "loading_title4.webp": title4,
};

const LoadingPage = () => {
  const navigate = useNavigate();
  const { selectRandomPrayer } = usePrayerSelector();
  const [currentTitleSrc, setCurrentTitleSrc] = useState("");
  const [titleKey, setTitleKey] = useState(0);
  const [isChangingTitle, setIsChangingTitle] = useState(false);

  const { currentSlide, showWhosNext, isAnimating, startAnimation, slides } =
    useLoadingAnimation(() => {
      // 애니메이션 완료 후 기도제목 선택하고 결과 페이지로 이동
      console.log(
        "Loading animation complete - selecting prayer and navigating"
      );

      // GA4 이벤트 추적: 로딩 완료
      trackLoadingComplete();

      selectRandomPrayer();
      console.log("Navigating to /result");
      navigate("/result");
    });

  useEffect(() => {
    // 페이지 로드 시 애니메이션 시작
    startAnimation();
  }, [startAnimation]);

  // 현재 슬라이드가 변경될 때 타이틀 업데이트 - 부드러운 전환
  useEffect(() => {
    if (slides && slides[currentSlide]) {
      const newTitleSrc = titleImageMap[slides[currentSlide].title];

      if (currentTitleSrc && newTitleSrc !== currentTitleSrc) {
        // 타이틀이 변경되는 경우 부드러운 전환
        setIsChangingTitle(true);

        // 페이드 아웃 후 새 타이틀로 변경
        setTimeout(() => {
          setCurrentTitleSrc(newTitleSrc);
          setTitleKey((prev) => prev + 1);
          setIsChangingTitle(false);
        }, 120); // 더 빠른 전환
      } else if (!currentTitleSrc) {
        // 첫 번째 타이틀 설정
        setCurrentTitleSrc(newTitleSrc);
        setTitleKey((prev) => prev + 1);
      }
    }
  }, [currentSlide, slides, currentTitleSrc]);

  // WhosNext 컴포넌트가 표시된 후 일정 시간 후 결과 페이지로 이동
  useEffect(() => {
    if (showWhosNext) {
      const timer = setTimeout(() => {
        console.log("WhosNext 표시 완료 - 결과 페이지로 이동");
        selectRandomPrayer();
        navigate("/result");
      }, 3500); // 3.5초 후 이동 - 이미지 표시 후 더 오래 유지

      return () => clearTimeout(timer);
    }
  }, [showWhosNext, selectRandomPrayer, navigate]);

  return (
    <Layout fullHeight className={styles.loadingPage}>
      {!showWhosNext ? (
        <>
          <SlideShow
            slides={slides}
            currentSlide={currentSlide}
            isAnimating={isAnimating}
          />

          {/* 개선된 타이틀 관리 - 부드러운 전환 */}
          {currentTitleSrc && (
            <div className={styles.titleContainer}>
              <img
                key={titleKey}
                src={currentTitleSrc}
                alt="로딩 타이틀"
                className={`${styles.titleImage} ${
                  isChangingTitle ? styles.titleChanging : ""
                }`}
              />
            </div>
          )}
        </>
      ) : (
        <WhosNext />
      )}
    </Layout>
  );
};

export default LoadingPage;
